<template>
  <CommonModal>
    <template slot="header">
      <h3>Update Controller Type</h3>
    </template>
    <template slot="body">
      <div style="overflow: auto; height: 450px">
        <table class="write_tbl">
          <tbody>
            <tr>
              <th>ID</th>
              <td>{{controllerVO.controllerId}}</td>
            </tr>
            <tr>
              <th>이름</th>
              <td>
                <input
                  type="text"
                  name="doctypeName"
                  class="form-control"
                  v-model="controllerVO.controllerName"
                  v-validate="'required'"
                />
              </td>
            </tr>
            <tr>
              <th>설명</th>
              <td colspan="2">
                <textarea
                  class="form-control"
                  name="doctypeDesc"
                  v-model="controllerVO.controllerDesc"
                ></textarea>
              </td>
            </tr>
            <tr>
              <th>사용여부</th>
              <td>
                <label
                  ><input
                    type="radio"
                    name="useYn"
                    v-model="controllerVO.useYn"
                    value="Y"
                  />
                  Use</label
                >
                <label
                  ><input
                    type="radio"
                    name="useYn"
                    v-model="controllerVO.useYn"
                    value="N"
                  />
                  Unused</label
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template slot="footer">
      <slot name="footer"> </slot>
    </template>
  </CommonModal>
</template>

<script>
import CommonModal from "@/components/modal/CommonModal";
import {
  getControllerType,
  update,
  checkControllerTypeNameDuplication,
} from "@/api/controllertype";

export default {
  components: {
    CommonModal,
  },
  data() {
    return {
      controllerVO: {
        controllerId: "",
        controllerName: "",
        controllerDesc: "",
        useYn: "Y",
      },
      languages: [],
      controller: "",
    };
  },
  methods: {
    async fetchData(id) {
      try {
        const response = await getControllerType(id);
        console.log(response);
        this.controllerVO = response.data.controllerVO;
      } catch (error) {
        console.log(error);
      }
    },
    async update() {
      const validForm = await this.$validator.validateAll();
      if (validForm) {
        //ControllerTypeName 중복확인
        const { data } = await checkControllerTypeNameDuplication(this.controllerVO);
        this.controller = data.controllerType;
        if (this.controller == null || this.controller == "" || this.controller.length == 0) {
          try {
            const response = await update(this.controllerVO);
            return response.data.status;
          } catch (error) {
            console.log(error);
          }
        } else {
          return "alert.alreadyExist";
        }
      } else {
        return "alert.plzCheckAllValues";
      }
    },
  },
};
</script>

<style></style>
